/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_117Inputs */

const cs_ares_legal_form_117 = /** @type {(inputs: Ares_Legal_Form_117Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadace`)
};

const en_ares_legal_form_117 = /** @type {(inputs: Ares_Legal_Form_117Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foundation`)
};

/**
* | output |
* | --- |
* | "Foundation" |
*
* @param {Ares_Legal_Form_117Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_117 = /** @type {((inputs?: Ares_Legal_Form_117Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_117Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_117(inputs)
	return cs_ares_legal_form_117(inputs)
});